module.exports = __webpack_public_path__ + "static/Heat-Stress-b3ab221ed4a3199b7476273d4795cf02.jpg";